import React from 'react';
import PropTypes from 'prop-types';

const LanguagePicker = ({ language, setLanguage }) => {
    return (
        <div
            className="btn-group btn-group-sm"
            role="group"
            aria-label="Language selection"
            style={{ marginBottom: '1em' }}
        >
            <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="en"
                autoComplete="off"
                checked={language === 'en'}
                onChange={() => setLanguage('en')}
                onClick={e => e.stopPropagation()}
            />
            <label className="btn btn-outline-primary" htmlFor="en">
                English
            </label>

            <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="es"
                autoComplete="off"
                checked={language === 'es'}
                onChange={() => setLanguage('es')}
                onClick={e => e.stopPropagation()}
            />
            <label className="btn btn-outline-primary" htmlFor="es">
                Español
            </label>
        </div>
    );
};

LanguagePicker.propTypes = {
    language: PropTypes.string.isRequired,
    setLanguage: PropTypes.func.isRequired,
};

export default LanguagePicker;
